import onboardingRouter from 'routing/router/onboarding'
import clientRouter from 'routing/router/client'

const selectRouter = (app) => {
  switch (app) {
    case 'onboarding':
      return onboardingRouter
    case 'client':
      return clientRouter
    default:
      return {}
  }
}

export const isAppRoute = (app, route) => {
  const selectedRouter = selectRouter(app)
  const routes = Object.keys(selectedRouter)
  return routes.includes(route)
}

export default {
  ...onboardingRouter,
  ...clientRouter
}



// WEBPACK FOOTER //
// ./src/routing/router/index.js